/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_Australia_New_ZealandInputs */

const bn_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অস্ট্রেলিয়া ও নিউজিল্যান্ড`)
};

const de_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australien und Neuseeland`)
};

const el_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αυστραλία και Νέα Ζηλανδία`)
};

const en_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australia and New Zealand`)
};

const es_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australia y Nueva Zelanda`)
};

const fr_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australie et Nouvelle-Zélande`)
};

const hi_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑस्ट्रेलिया और न्यूजीलैंड`)
};

const hu_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausztrália és Új-Zéland`)
};

const id_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australia dan Selandia Baru`)
};

const it_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australia e Nuova Zelanda`)
};

const ja_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーストラリアとニュージーランド`)
};

const ko_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`호주와 뉴질랜드`)
};

const nl_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australië en Nieuw-Zeeland`)
};

const pl_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australii i Nowej Zelandii`)
};

const pt_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Austrália e Nova Zelândia`)
};

const ru_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Австралия и Новая Зеландия`)
};

const sv_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australien och Nya Zeeland`)
};

const tr_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avustralya ve Yeni Zelanda`)
};

const uk_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Австралії та Нової Зеландії`)
};

const vi_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úc và New Zealand`)
};

const zh_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`澳大利亚和新西兰`)
};

const zh_hant_geo_label_australia_new_zealand = /** @type {(inputs: Geo_Label_Australia_New_ZealandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`澳洲和紐西蘭`)
};

/**
* | output |
* | --- |
* | "Australia and New Zealand" |
*
* @param {Geo_Label_Australia_New_ZealandInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_australia_new_zealand = /** @type {((inputs?: Geo_Label_Australia_New_ZealandInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_Australia_New_ZealandInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_australia_new_zealand(inputs)
	if (locale === "de") return de_geo_label_australia_new_zealand(inputs)
	if (locale === "el") return el_geo_label_australia_new_zealand(inputs)
	if (locale === "en") return en_geo_label_australia_new_zealand(inputs)
	if (locale === "es") return es_geo_label_australia_new_zealand(inputs)
	if (locale === "fr") return fr_geo_label_australia_new_zealand(inputs)
	if (locale === "hi") return hi_geo_label_australia_new_zealand(inputs)
	if (locale === "hu") return hu_geo_label_australia_new_zealand(inputs)
	if (locale === "id") return id_geo_label_australia_new_zealand(inputs)
	if (locale === "it") return it_geo_label_australia_new_zealand(inputs)
	if (locale === "ja") return ja_geo_label_australia_new_zealand(inputs)
	if (locale === "ko") return ko_geo_label_australia_new_zealand(inputs)
	if (locale === "nl") return nl_geo_label_australia_new_zealand(inputs)
	if (locale === "pl") return pl_geo_label_australia_new_zealand(inputs)
	if (locale === "pt") return pt_geo_label_australia_new_zealand(inputs)
	if (locale === "ru") return ru_geo_label_australia_new_zealand(inputs)
	if (locale === "sv") return sv_geo_label_australia_new_zealand(inputs)
	if (locale === "tr") return tr_geo_label_australia_new_zealand(inputs)
	if (locale === "uk") return uk_geo_label_australia_new_zealand(inputs)
	if (locale === "vi") return vi_geo_label_australia_new_zealand(inputs)
	if (locale === "zh") return zh_geo_label_australia_new_zealand(inputs)
	return zh_hant_geo_label_australia_new_zealand(inputs)
});